<template>
  <span class="badge" :class="style"><slot></slot></span>
</template>

<script>
export default {
  name: 'StatusLabel',
  props: {
    variation: {
        type: String,
        required: false
    }
  },
  computed: {
    style: function () {
      switch (this.variation) {
        case 'info':
          return 'badge-color-info';
        case 'warning':
          return 'badge-color-warning';
        case 'none':
          return 'badge-color-ghost';
        case 'success':
          return 'badge-color-success';
        case 'alarm':
          return 'badge-color-alarm';
        case 'danger':
          return 'badge-color-danger';
        case 'silent':
          return 'badge-color-silent';
        default:
          return 'badge-color-info';
      }
    }
  },
}
</script>

<style scoped>
.badge {
    border: 1px solid;
    border-radius: 10rem;
    padding: 2px 8px;
    font-size: 0.875rem;
    font-weight: 700;
    display: inline-flex;
    height: 24px;
    align-items: center;
}

.badge-color-info {
  border-color: #007bff;
  background-color: #3395ff;
  color: white;
}

.badge-color-warning {
  border-color: #ffdd99;
  background-color: #ffeecc;
  color: #5c3d00;
}

.badge-color-alarm {
  border-color: #e35c0b;
  background-color: #e97d3c;
  color: white;
}

.badge-color-success {
  border-color: #28a745;
  background-color: #52b96a;
  color: white;
}

.badge-color-danger {
  border-color: #e50b0b;
  background-color: #e93c3c;
  color: white;
}

.badge-color-silent {
  border-color: #e0e0e0;
  background-color: #f5f5f5;
  color: #3d3d3d;
}

.badge-color-ghost {
  border: none;
}

</style>